<script>
import appConfig from '@/app.config'

export default {
  page: {
    title: '403 Error Page',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      hasButton: true,
    }
  },
  created() {
    const fcId = document.getElementById('custom_fc_button')
    if (fcId) {
      fcId.style = 'display: none'
    }
  },
  mounted() {
    const storedData = localStorage.getItem('403') || sessionStorage.getItem('403')
    if (storedData) {
      this.data = JSON.parse(storedData)
      this.hasButton = this.data.hasButton !== undefined ? this.data.hasButton : true
    }

    localStorage.removeItem('403')
    sessionStorage.removeItem('403')
  },
}
</script>
<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 fw-medium">
              4<i class="bx bx-buoy bx-spin text-primary display-3"></i>3
            </h1>
            <h4 class="text-uppercase">Sorry, access forbidden</h4>
            <div class="mt-5 text-center" v-if="hasButton">
              <router-link class="btn btn-primary" to="/">Back to Dashboard</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
